import React from 'react'

const LeftArrow: React.FC = () => {
  return (
    <svg
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.12583 1.7925L5.83333 0.5L0.333328 6L5.83333 11.5L7.12583 10.2075L2.9275 6L7.12583 1.7925Z"
        fill="#003760"
      />
    </svg>
  )
}

export default LeftArrow
